const normalizePath = (pathname) => {
  const path = String(pathname || '').trim()
  if (!path || path === '/') return '/'
  return path.endsWith('/') ? path.slice(0, -1) : path
}

export const TRACKED_REPORTS = [
  {
    id: 'access-control-summary',
    title: 'Access Control Summary',
    paths: [
      '/access-control-summary',
      '/access-control-summary-v2',
      '/reporting/access-control-summary',
      '/reporting/access-control-summary-v2',
    ],
  },
  {
    id: 'access-pass-holders',
    title: 'Access Pass Holders',
    paths: ['/access-pass-holders'],
  },
  {
    id: 'time-stamp-report',
    title: 'Time Stamp Report',
    paths: ['/time-stamp-report'],
  },
  {
    id: 'daily-ticket-counts',
    title: 'Daily Ticket Counts',
    paths: ['/daily-tickets-count'],
  },
  {
    id: 'sales-attendance',
    title: 'Event Sales & Attendance',
    paths: ['/sales-attendance'],
  },
  {
    id: 'comp-intelligence',
    title: 'Complimentary Intelligence',
    paths: ['/comp-intelligence'],
  },
  {
    id: 'sales-velocity',
    title: 'Sales Velocity',
    paths: ['/sales-velocity'],
  },
  {
    id: 'pricing-level-performance',
    title: 'Pricing Level Performance',
    paths: ['/pricing-level-performance'],
  },
  {
    id: 'attendance-intelligence',
    title: 'Attendance Intelligence',
    paths: ['/attendance-intelligence'],
  },
  {
    id: 'geographic-sales-intelligence',
    title: 'Geographic Sales Intelligence',
    paths: ['/geographic-sales-intelligence'],
  },
  {
    id: 'weather-event-analytics',
    title: 'Weather Event Analytics',
    paths: ['/weather-event-analytics'],
  },
  {
    id: 'fnb-analytics',
    title: 'F&B Analytics',
    paths: ['/fnb-analytics'],
  },
  {
    id: 'fnb-eod-report',
    title: 'F&B End of Day Report',
    paths: ['/fnb-eod-report'],
  },
  {
    id: 'revenue-insights',
    title: 'Revenue Insights',
    paths: ['/revenue-insights'],
  },
  {
    id: 'insights-dashboard',
    title: 'Insights Dashboard',
    paths: ['/insights-dashboard'],
  },
  {
    id: 'daily-settlement',
    title: 'Daily Settlement Report',
    paths: ['/daily-settlement'],
  },
  {
    id: 'summary-by-payment-method',
    title: 'Summary by Payment Method Report',
    paths: ['/summary-by-payment-method'],
  },
  {
    id: 'custom-fee-report',
    title: 'Custom Fee Report',
    paths: ['/custom-fee-report'],
  },
  {
    id: 'henson-fund-report',
    title: 'Henson Fund Report',
    paths: ['/henson-fund-report'],
  },
  {
    id: 'payouts-report',
    title: 'Payouts Report',
    paths: ['/payouts-report'],
  },
  {
    id: 'report-builder',
    title: 'Custom Report Builder',
    paths: ['/report-builder'],
  },
  {
    id: 'order-listings',
    title: 'Order Listings',
    paths: ['/order-listings'],
  },
  {
    id: 'season-report',
    title: 'Season Report',
    paths: ['/season-report'],
  },
  {
    id: 'ar-aging-details',
    title: 'A/R Aging Details',
    paths: ['/ar-aging-details'],
  },
  {
    id: 'ar-aging-summary',
    title: 'A/R Aging Summary',
    paths: ['/ar-aging-summary'],
  },
  {
    id: 'sales-receivables-by-category',
    title: 'Sales & Receivables by Category',
    paths: ['/sales-receivables-by-category'],
  },
  {
    id: 'buyer-types-report',
    title: 'Buyer Types Report',
    paths: ['/buyer-types-report'],
  },
  {
    id: 'payment-plans-report',
    title: 'Payment Plans',
    paths: ['/payment-plans-report'],
  },
  {
    id: 'client-report',
    title: 'Client Report',
    paths: ['/client-report'],
  },
  {
    id: 'accounting-report',
    title: 'Accounting',
    paths: ['/accounting-report'],
  },
  {
    id: 'settlement-report',
    title: 'Settlement Report',
    paths: ['/settlement-report'],
  },
  {
    id: 'sales-summary-report',
    title: 'Sales Summary Report',
    paths: ['/sales-summary-report'],
  },
  {
    id: 'payment-method-type-report',
    title: 'Payment Method Type Report',
    paths: ['/payment-method-type-report'],
  },
  {
    id: 'packages-report',
    title: 'Packages Report',
    paths: ['/packages-report'],
  },
  {
    id: 'flex-package-sales-summary',
    title: 'Flex Package Sales Summary',
    paths: ['/flex-package-sales-summary'],
  },
  {
    id: 'aged-receivables',
    title: 'Aged Receivables',
    paths: ['/aged-receivables'],
  },
  {
    id: 'user-balance-totals',
    title: 'User Balance Totals',
    paths: ['/user-balance-totals'],
  },
  {
    id: 'organization-dashboard',
    title: 'Organization Dashboard',
    paths: ['/organization-dashboard'],
  },
  {
    id: 'season-summary',
    title: 'Season Summary',
    paths: ['/season-summary'],
  },
  {
    id: 'deferred-revenue',
    title: 'Season Deferred Revenue',
    paths: ['/deferred-revenue'],
  },
  {
    id: 'flex-pack-deferred-revenue',
    title: 'Flex Pack Deferred Revenue',
    paths: ['/flex-pack-deferred-revenue'],
  },
  {
    id: 'scans-chart',
    title: 'Scans Chart',
    paths: ['/scans-chart'],
  },
  {
    id: 'ticket-matrix',
    title: 'Ticket Matrix',
    paths: ['/ticket-matrix'],
  },
  {
    id: 'club-seats',
    title: 'Club Seats',
    paths: ['/club-seats'],
  },
  {
    id: 'analytics',
    title: 'Analytics',
    paths: ['/analytics'],
  },
]

const matchesReportPath = (pathname, reportPath) => {
  if (pathname === reportPath) return true
  return pathname.startsWith(`${reportPath}/`)
}

export const resolveTrackedReport = (pathname) => {
  const normalizedPath = normalizePath(pathname)

  for (const report of TRACKED_REPORTS) {
    const matched = (report.paths || []).some((reportPath) =>
      matchesReportPath(normalizedPath, reportPath)
    )
    if (matched) return report
  }

  return null
}
